import { SortingState } from "@tanstack/react-table";

import { DatatableColumn } from "../datatable-types";

export const resolveSortingFromUrl = (
  urlParams: URLSearchParams,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): SortingState | undefined => {
  const sorting = urlParams.get("sorting");

  if (!sorting) {
    return undefined; // Return undefined if no sorting is found
  }

  try {
    const parsedSorting = JSON.parse(decodeURIComponent(sorting)) as SortingState;

    // Validate column IDs and desc values against the provided columns configuration using flatMap
    const filteredSorting: SortingState = parsedSorting.flatMap(({ id, desc }) => {
      const column = columns.find((col) => col.columnId === id);

      // Ensure desc is a valid boolean
      const isDescValid = desc === true || desc === false;

      // Include the column only if it exists, has `enableSorting: true`, and desc is valid
      if (column && column.getColumnDef().enableSorting && isDescValid) {
        return [{ id, desc }];
      }

      return [];
    });

    return filteredSorting; // Return only valid sorting states
  } catch (error) {
    console.error("Failed to parse sorting from URL:", error);
    return undefined;
  }
};

export const encodeSortingToUrl = (
  urlParams: URLSearchParams,
  sorting: SortingState | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): URLSearchParams => {
  const updatedParams = new URLSearchParams(urlParams);

  if (sorting) {
    // Validate column IDs against the provided columns configuration
    const validSorting: SortingState = sorting.flatMap(({ id, desc }) => {
      const column = columns.find((col) => col.columnId === id);

      // Include the column only if it exists and has `enableSorting: true`
      if (column && column.getColumnDef().enableSorting) {
        return [{ id, desc }];
      }

      return [];
    });

    updatedParams.set("sorting", JSON.stringify(validSorting)); // Convert the filtered array to a JSON string
  } else {
    updatedParams.delete("sorting"); // Remove the parameter if the value is undefined
  }

  return updatedParams;
};
